const initialState = {
  loadingContext: false,
  context: {
    sftpUsername: undefined,
    processorTypes: [],
    processorStatus: [],
  },
  customDataSetModalOpen: false,
  customDataSet: {},
  processorGroups: [],
  searchResultMeta: {
    count: undefined,
    next: undefined,
    previous: undefined,
  },
  uploadHistory: [],
  activeFilters: {
    limit: 10,
    offset: 0,
  },
  filterCtl: {},
  uploadDetail: {
    runs: [],
  },
  exampleIdentifiers: {
    student: {},
    staff: {},
    school: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'DATA_INTEGRATION.POPULATE_DISTRICT_CONTEXT':
      return {
        ...state,
        context: {
          ...state.context,
          ...action.context,
        },
      };
    case 'DATA_INTEGRATION.POPULATE_PROCESSOR_GROUPS':
      return {
        ...state,
        processorGroups: action.processorGroups,
      };
    case 'DATA_INTEGRATION.POPULATE_SEARCH_RESULT':
      return {
        ...state,
        searchResultMeta: action.searchResultMeta,
        uploadHistory: action.uploadHistory,
      };
    case 'DATA_INTEGRATION.POPULATE_ACTIVE_FILTERS':
      return {
        ...state,
        activeFilters: action.activeFilters,
      };
    case 'DATA_INTEGRATION.POPULATE_FILTER_CTL':
      return {
        ...state,
        filterCtl: action.filterCtl,
      };
    case 'DATA_INTEGRATION.POPULATE_UPLOAD_DETAIL':
      return {
        ...state,
        uploadDetail: action.uploadDetail,
      };
    case 'DATA_INTEGRATION.SET_CUSTOM_DATA_SET_DETAILS':
      return {
        ...state,
        customDataSet: { ...state.customDataSet, ...action.details },
      };
    case 'DATA_INTEGRATION.RESET_CUSTOM_DATA_DETAILS':
      return {
        ...state,
        customDataSet: {},
      };
    case 'DATA_INTEGRATION.SET_LOADING':
      return {
        ...state,
        loadingContext: action.mode,
      };
    case 'DATA_INTEGRATION.POPULATE_EXAMPLE_IDENTIFIERS':
      return {
        ...state,
        exampleIdentifiers: action.exampleIdentifiers,
      };
    default:
      return state;
  }
};
